import React, { FC, PropsWithChildren } from 'react';

import EmptyState from '../EmptyState';

import { ReactComponent as EmptyStateNoSectionsIcon } from 'resources/img/svg/emptyStateNoSections.svg';

import { DefaultEmptyStateProps } from '../interfaces';

const NoSectionsYet: FC<PropsWithChildren<DefaultEmptyStateProps>> = ({ children }) => (
  <EmptyState size="lg" icon={EmptyStateNoSectionsIcon}>
    {children}
  </EmptyState>
);
export default NoSectionsYet;
